<template>
  <!--
      作者 kmdshop
      时间：2019-10-26
      描述：设置-商城设置
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加门店-->
      <div class="common-form">成为商家</div>
      <el-form-item label="保证金" :rules="[{required: true,message: ' '}]" prop="sj_deposit">
        <el-input v-model="form.sj_deposit" placeholder="保证金" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="入驻费" :rules="[{required: true,message: ' '}]" prop="wxjs_deposit">
        <el-input v-model="form.wxjs_deposit" placeholder="入驻费" class="max-w460"></el-input>
      </el-form-item>
      <div class="common-form">成为维修技师</div>
      <el-form-item label="保证金" :rules="[{required: true,message: ' '}]" prop="sj_entry_fee">
        <el-input v-model="form.sj_entry_fee" placeholder="保证金" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="入驻费" :rules="[{required: true,message: ' '}]" prop="wxjs_entry_fee">
        <el-input v-model="form.wxjs_entry_fee" placeholder="入驻费" class="max-w460"></el-input>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>

  </div>

</template>

<script>
import SettingApi from '@/api/setting.js'
import _ from 'lodash'
export default {
  components: {
   
  },
  data() {
    return {
      /*是否正在加载*/
      loading: false,
     
      /*form表单数据*/
      form: {
        sj_deposit: '',
        wxjs_deposit: '',
        sj_entry_fee:"",
        wxjs_entry_fee: '',
      },
      type: [],
    }
  },
  created() {
    this.getParams()
  },

  methods: {
    /*获取配置数据*/
    getParams() {
      let self = this
      SettingApi.storeDetail({}, true).then(res => {
        if (res.code) {
          self.form = _.merge(self.form, res.data.vars.values)
          self.loading = false
        } else {
          self.$message.error('错了哦，这是一条错误消息')
        }
      }).catch(error => {
        console.log(error)
      })
    },


    /*提交*/
    onSubmit() {
      let self = this
      let params = this.form
    
      self.$refs.form.validate((valid) => {
        if (valid) {
          self.loading = true
          SettingApi.editMoney(params, true)
            .then(data => {
              self.loading = false
              self.$message({
                message: '恭喜你，设置成功',
                type: 'success',
              })
              self.$router.push('/setting/money/index')
            })
            .catch(error => {
              self.loading = false
            })
        }
      })
    },
    /*删除商品图片*/
    deleteImg() {
      this.form.about_banner = {
        file_id: '',
        file_path: ''
      }
    },
  
  },

}
</script>

<style scoped lang="scss">
.tips {
  color: #ccc;
}

.img-select {
  position: relative;
  width: 110px;
  height: 110px;
  margin-right: 10px;

  i {
    display: flex;
    line-height: 110px;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    border: 1px dashed #dddddd;
    font-size: 30px;
    color: #409eff;
  }
}

.image-box {
  width: 110px;
  height: 110px;
  overflow: hidden;

  img {
    width: 110px;
    //height: 110px;
  }
}

.image-box:hover .delete-btn {
  display: block;
}

.default-image-box {
  position: relative;
  width: 110px;
  height: 110px;
}

.delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/money/index.vue